import Swal from 'sweetalert2';

export const showSuccess = (message: string) => {
  return Swal.fire({
    icon: 'success',
    title: 'Success!',
    text: message,
    confirmButtonColor: '#28a745',
    timer: 3000,
    timerProgressBar: true
  });
};

export const showError = (message: string) => {
  return Swal.fire({
    icon: 'error',
    title: 'Error',
    text: message,
    confirmButtonColor: '#dc3545'
  });
};

export const showConfirm = async (title: string, text: string): Promise<boolean> => {
  const result = await Swal.fire({
    icon: 'question',
    title,
    text,
    showCancelButton: true,
    confirmButtonColor: '#007bff',
    cancelButtonColor: '#6c757d',
    confirmButtonText: 'Yes, proceed',
    cancelButtonText: 'Cancel'
  });
  
  return result.isConfirmed;
};

export const showInput = async (title: string, placeholder: string, defaultValue?: string): Promise<string | null> => {
  const result = await Swal.fire({
    title,
    input: 'text',
    inputPlaceholder: placeholder,
    inputValue: defaultValue || '',
    showCancelButton: true,
    confirmButtonColor: '#007bff',
    cancelButtonColor: '#6c757d',
    inputValidator: (value) => {
      if (!value) {
        return 'This field is required';
      }
      return null;
    }
  });
  
  return result.isConfirmed ? result.value : null;
};
